import PropTypes from 'prop-types';
import React from 'react';

import Label from '../formsUi/common/label/Label';
import ValidationMessage from '../formsUi/common/validation/ValidationMessage';
import EditableDropdown from '../formsUi/editableDropdown/EditableDropdown';

const FormEditableDropdownControls = ({
    labelName,
    name,
    keyId,
    value,
    error,
    formSetting,
    dataField,
    isRequired,
    fieldSetting,
    onChange,
    onBlure,
    onActionChange,
    ...otherProps
}) => {

    const handleInputChange = (e, fieldType, selectedValue) => {
        if (onChange) {
            if (fieldType === "input") {
                onChange(dataField, { text: e, isNewValue: true });
            } else if (fieldType === "dropdown") {
                onChange(dataField, selectedValue.value);
            }
        }
    };
    const handleOnBlur = () => {
        onBlure?.(dataField);
    };

    return (
        <>
            <div className="input-label-part">
                {labelName && (
                    <Label labelName={labelName} isRequired={isRequired} htmlFor={name} />
                )}
                {fieldSetting?.subTitle && (
                    <div className="section-title">
                        <h5>{fieldSetting.subTitle}</h5>
                    </div>
                )}
                <EditableDropdown
                    keyId={keyId}
                    name={name}
                    options={fieldSetting?.options}
                    dataField={dataField}
                    onChange={handleInputChange}
                    onBlur={handleOnBlur}
                    value={value}
                    placeholder={fieldSetting?.placeholder}
                    isText={fieldSetting?.isText}
                    {...otherProps}
                    formSetting={formSetting}
                />
            </div>
            <ValidationMessage error={error}
                helperText={fieldSetting?.helperText}
                successText={fieldSetting?.successText} />
        </>
    );
}

FormEditableDropdownControls.propTypes = {
    labelName: PropTypes.string,
    name: PropTypes.string.isRequired,
    keyId: PropTypes.string.isRequired,
    value: PropTypes.any,
    error: PropTypes.string,
    isRequired: PropTypes.bool,
    formSetting: PropTypes.object,
    dataField: PropTypes.string.isRequired,
    fieldSetting: PropTypes.shape({
        options: PropTypes.arrayOf(PropTypes.object),
        placeholder: PropTypes.string,
        subTitle: PropTypes.string,
        isFormControl: PropTypes.bool,
    }),
    onChange: PropTypes.func,
    onBlure: PropTypes.func,
    onActionChange: PropTypes.func,
    isText: PropTypes.bool,
};

FormEditableDropdownControls.defaultProps = {
    labelName: '',
    value: '',
    error: '',
    isRequired: false,
    fieldSetting: {},
    onChange: null,
    onBlure: null,
};

export default FormEditableDropdownControls;